module.exports = __webpack_public_path__ + "static/media/tvshows-edutainment-banner.bd42237b.png";